import React from 'react';
import PropTypes from 'prop-types';
import { mapCreatorConnect } from '../../higher-order-components';
import {
  Row,
  Col,
  ButtonGroup,
  Button
} from 'react-bootstrap';

class MapPanelFeature extends React.Component {
  constructor(props) {
    super(props);

    this.handleDeleteSwath = this.handleDeleteSwath.bind(this);
    this.handleChangeFeatureZIndex = this.handleChangeFeatureZIndex.bind(this);
  }

  handleDeleteSwath(map_id, feature_id) {
    this.props.sendSocketEmit({ map_id, feature_id }, 'delete-map-feature');
  }
  handleChangeFeatureZIndex(feature, map_id, z_index) {
    const updated_feature = {
      ...feature,
      properties: {
        ...feature.properties,
        zIndex: z_index
      }
    };
    this.props.updateCurrentMapFeature(updated_feature, map_id);
  }

  render() {
    const { map, feature, idx } = this.props;
    const {
      show_delete_feature_confirmation,
      hidden_features,
      current_map,
      current_feature,
      deleting_feature_id
     } = this.props.mapCreator;
    const hidden = hidden_features.includes(feature.properties._id);
    const selected = current_feature && current_feature.properties._id == feature.properties._id && current_map._id == map._id;

    if(deleting_feature_id && (deleting_feature_id == feature.properties._id)) {
      return (
        <div className='alert alert-warning mt-sm mb-sm p-sm'>
          <p>Are you sure you want to delete this?</p>
          <ButtonGroup>
            <Button onClick={this.props.cancelDeleteMapFeature} bsStyle={'default'}>No</Button>
            <Button onClick={() => this.handleDeleteSwath(map._id, feature.properties._id)} bsStyle={'danger'}>Yes</Button>
          </ButtonGroup>
        </div>
      )
    }
    return (
      <li className={selected ? 'alert alert-default alert-xs animated fadeIn mb-sm mt-sm p-sm' : ''}>
        <Row>
          <Col xs={7} md={7}>
            <span className='text-dark'>
              {idx + 1} - {feature.geometry.type} - Z Index - {feature && feature.properties ? feature.properties.zIndex : ''}
            </span>
          </Col>
          <Col xs={5} md={5}>
            <ButtonGroup>
              <Button
                bsSize='xsmall'
                onClick={() => this.props.toggleFeatureHidden(feature.properties._id)}
                >
                <i className={hidden ? 'fa fa-eye-slash' : 'fa fa-eye'} />
              </Button>
              <Button
                bsSize='xsmall'
                onClick={() => this.props.initDeleteMapFeature(feature.properties._id)}
                >
                <i className='fa fa-trash' />
              </Button>
            </ButtonGroup>
          </Col>
        </Row>
        {selected ? (
          <div className='input-group'>
            <div className='input-group-addon'>Z Index</div>
            <input
              className='form-control text-dark'
              type='number'
              onChange={e => this.handleChangeFeatureZIndex(feature, map._id, Number(e.target.value))}
              value={feature.properties.zIndex || 0}
           />
          </div>
        ) : null}
      </li>
    );
  }
}

export default mapCreatorConnect(MapPanelFeature);



// WEBPACK FOOTER //
// ./src/browser/components/map-creator/map-panel-feature.js